import { Fragment, useCallback, type FC, type PropsWithChildren } from 'react';

import { MainPageHeader } from '#packages/web/layouts/page/header';
import {
  PageContent,
  type PageContentProps,
} from '#packages/web/layouts/page/page-content';

import { useDrawer } from '#apps/client-web/app/hooks/use-drawer';

import { PageErrorBoundary } from './page-error-boundary';

export type MainPageLayoutProps = {
  /**
   * Title to display at the top of the page.
   */
  title: string;

  /**
   * Props to pass to the PageContent component.
   */
  pageContentProps?: Partial<PageContentProps>;

  /**
   * Callback when the error boundary action button is clicked.
   */
  onErrorActionClick?: () => void;

  /**
   * Optional toolbar to display below the header.
   */
  toolbar?: React.ReactNode;
};

export const MainPageLayout: FC<PropsWithChildren<MainPageLayoutProps>> = ({
  title,
  toolbar,

  pageContentProps,
  onErrorActionClick = useCallback(() => window.location.reload(), []),

  children,
}) => {
  const drawer = useDrawer();

  return (
    <Fragment>
      <MainPageHeader title={title} onNavigationIconClick={drawer.open}>
        {toolbar}
      </MainPageHeader>
      <PageContent {...pageContentProps}>
        <PageErrorBoundary onActionClick={onErrorActionClick}>
          {children}
        </PageErrorBoundary>
      </PageContent>
    </Fragment>
  );
};
